import React from 'react'

import { useDocumentCardContext } from '../../context'
import { Classification } from './classification'
import { ClassificationFailed } from './classification-failed'

export function ClassificationContent() {
  const { hideClassification, hasSupportedClassification, classificationResults } = useDocumentCardContext()

  if (hideClassification) return null

  if (hasSupportedClassification) {
    return <Classification classifications={classificationResults} />
  }

  return <ClassificationFailed classificationResults={classificationResults} />
}
